<template>
    <div>
        <el-form ref="form" class="attributes-form" :model="locationInfo" label-position="top">
            <el-row>

                <el-col :span="24">
                    <el-form-item label="Secret tags (staff only)">
                        <el-tag
                                :key="tag"
                                v-for="tag in locationInfo.staffTags"
                                closable
                                :disable-transitions="false"
                                @close="handleClose(tag)">
                            {{tag}}
                        </el-tag>
                        <el-input
                                class="input-new-tag"
                                v-if="inputVisible"
                                v-model="inputValue"
                                ref="saveTagInput"
                                size="small"
                                @keyup.enter.native="handleInputConfirm"
                                @blur="handleInputConfirm"
                        >
                        </el-input>
                        <el-button v-else class="button-new-tag" size="small" @click="showInput">+ New Tag</el-button>
                    </el-form-item>

                </el-col>
            </el-row>
            <el-row>


                <el-form-item label="Suitable For" prop="type">
                    <el-checkbox-group v-model="locationInfo.attributes">

                        <el-checkbox v-for="item in this.suitableFor" :label="item.id" :key="item.id">{{ item.title }}
                        </el-checkbox>

                    </el-checkbox-group>
                </el-form-item>

                <el-form-item label="Building Type" prop="type">
                    <el-checkbox-group v-model="locationInfo.attributes">

                        <el-checkbox v-for="item in this.buildingType" :label="item.id" :key="item.id">{{ item.title
                            }}
                        </el-checkbox>

                    </el-checkbox-group>
                </el-form-item>

                <el-form-item label="Exterior Style" prop="type">
                    <el-checkbox-group v-model="locationInfo.attributes">

                        <el-checkbox v-for="item in this.exteriorStyle" :label="item.id" :key="item.id">{{ item.title
                            }}
                        </el-checkbox>

                    </el-checkbox-group>
                </el-form-item>

                <el-form-item label="Interior Style" prop="type">
                    <el-checkbox-group v-model="locationInfo.attributes">

                        <el-checkbox v-for="item in this.interiorStyle" :label="item.id" :key="item.id">{{ item.title
                            }}
                        </el-checkbox>

                    </el-checkbox-group>
                </el-form-item>

                <el-form-item label="Outside Spaces" prop="type">
                    <el-checkbox-group v-model="locationInfo.attributes">

                        <el-checkbox v-for="item in this.outsideSpaces" :label="item.id" :key="item.id">{{ item.title
                            }}
                        </el-checkbox>

                    </el-checkbox-group>
                </el-form-item>

            </el-row>

            <div class="form-actions">
                <el-button type="primary" @click="onSubmit">Save</el-button>
            </div>


        </el-form>


    </div>
</template>

<script>
    export default {
        props: ['location'],
        data() {
            return {
                inputVisible: false,
                inputValue: '',

                locationInfo: '',

                suitableFor: [],
                buildingType: [],
                exteriorStyle: [],
                interiorStyle: [],
                outsideSpaces: [],


            }
        },
        methods: {
            // METHODS FOR TAGS
            handleClose(tag) {
                this.locationInfo.staffTags.splice(this.locationInfo.staffTags.indexOf(tag), 1);
            },

            showInput() {
                this.inputVisible = true;
                this.$nextTick(_ => {
                    this.$refs.saveTagInput.$refs.input.focus();
                });
            },

            handleInputConfirm() {
                let inputValue = this.inputValue;
                if (inputValue) {
                    this.locationInfo.staffTags.push(inputValue);
                }
                this.inputVisible = false;
                this.inputValue = '';
            },

            // METHOD TAGS END
            onSubmit() {


                this.axios.patch(`${process.env.VUE_APP_ROOT_API}/api/locations/${this.location._id}`,
                    this.locationInfo,
                    {
                        headers: {
                            Authorization: localStorage.getItem('Authorization')
                        }
                    })
                    .then(response => {

                        console.log(response.data);

                        this.$notify({
                            title: 'Success',
                            message: 'Location updated.',
                            type: 'success'
                        });

                    })
                    .catch(error => {
                        console.log(error);

                    });

            },

            //Used for sorting objects in alphabetical order
            sortTitle(a, b) {
                return a.title > b.title ? 0 : -1;

            }

        },

        beforeMount() {

            //HERE WE NEED TO CHECK IF IT COMES FROM A PROP OR THE URL.

            if (!this.location) {

                console.log('LOCATION DOESNT EXIST');

                // We have to do find by ref because we dont have access to location ID at this point
                this.axios.get(`${process.env.VUE_APP_ROOT_API}/api/locations/findbyref/${this.$route.params.locationRef}`,
                    {
                        headers: {
                            Authorization: localStorage.getItem('Authorization')
                        }
                    })
                    .then(response => {
                        this.locationInfo = response.data;

                    })
                    .catch(error => {
                        console.log(error);
                    });


            } else {

                this.locationInfo = this.location;

            }


            // Get all the attributes
            this.axios.get(process.env.VUE_APP_ROOT_API + '/api/attributes', {
                headers: {
                    Authorization: localStorage.getItem('Authorization')
                }
            })
                .then(response => {

                    // console.log(response.data);

                    response.data.forEach((item, index) => {


                        if (item.type == 'Suitable For') {

                            this.suitableFor.push({id: item._id, title: item.title, type: item.type});

                        } else if (item.type == 'Building Type') {

                            this.buildingType.push({id: item._id, title: item.title, type: item.type});

                        } else if (item.type == 'Exterior Style') {

                            this.exteriorStyle.push({id: item._id, title: item.title, type: item.type});

                        } else if (item.type == 'Interior Style') {

                            this.interiorStyle.push({id: item._id, title: item.title, type: item.type});

                        } else if (item.type == 'Outside Spaces') {

                            this.outsideSpaces.push({id: item._id, title: item.title, type: item.type});

                        }

                    });

                    //  Sort them alphabetically.
                    this.suitableFor.sort(this.sortTitle);
                    this.buildingType.sort(this.sortTitle);
                    this.exteriorStyle.sort(this.sortTitle);
                    this.interiorStyle.sort(this.sortTitle);
                    this.outsideSpaces.sort(this.sortTitle);

                })
                .catch(error => {
                    console.log(error);

                });


        },
    }
</script>

<style scoped>
    .el-tag {
        margin: 0 8px 8px 0;
    }

    .button-new-tag {
        height: 32px;
        line-height: 30px;
        padding-top: 0;
        padding-bottom: 0;
    }

    .input-new-tag {
        width: 180px;
        vertical-align: top;
    }

    /* Each group is a section, with its options in tidy columns. */
    .attributes-form >>> .el-form-item {
        margin-bottom: 8px;
        padding: 16px 0;
        border-top: 1px solid var(--border);
    }

    .attributes-form >>> .el-form-item:first-child {
        border-top: none;
        padding-top: 0;
    }

    .attributes-form >>> .el-form-item__label {
        font-family: var(--font-heading);
        font-size: 16px;
        font-weight: 500;
    }

    .attributes-form >>> .el-checkbox-group {
        display: grid;
        grid-template-columns: repeat(auto-fill, minmax(190px, 1fr));
        gap: 4px 16px;
    }

    .attributes-form >>> .el-checkbox {
        margin-right: 0;
        line-height: 28px;
    }
</style>



// WEBPACK FOOTER //
// src/locations/LocationAttributes.vue